import React from 'react';
import './WhyusPartner.css';

const WhyusPartner = () => {
  return (
    <section className="whyuspartner-section" id="partnership">
      <h2 className="whyuspartner-heading">CREATING A STRONG PARTNERSHIP ALONG THE WAY</h2>
      <div className="whyuspartner-container">
        <p>
          At Lattice Labs, we pride ourselves on building strong partnerships with all our customers. These are built on{' '}
          <span className="highlight">transparency, trust, and cooperation</span>.
        </p>
        <p>
          You can expect a partner with{' '}
          <span className="highlight">strong worth ethics</span>, entirely focused on problem-solving and on building long-term engagements. That is why many of our customers stay with us for longer than two years.
        </p>
      </div>
    </section>
  );
};

export default WhyusPartner;
